<template>
<div class="row primary-filter">
  <div class="col-10 filter-grid">
    <ul>
      <li class="app-side-menu">
        <span @click="$router.go(-1)" class="pointer">
            <svgicon name="arrow-down" width="20" height="20" :original="true" class="back-arrow" />
        </span>
      </li>

      <li class="category">
        <div class="dropdown">
          <div class="dropdown-selected">
            <span v-if="hideEdits">Invoice</span>
            <span v-else>{{invoiceNo}}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <div class="col-2 filter-grid filter-button" v-if="hideEdits">
    <ul class="filter-btn-group">
      <li>
        <button class="btn btn-primary" @click="create">
          Generate Invoice
        </button>
      </li>
    </ul>
  </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable */
export default {
  props: ['paidto'],
  components: {

  },
  data() {
    return {
    };
  },
  computed: {
    hideEdits() {
      return !this.$store.showInvoice;
    },
    invoiceNo() {
      return this.$store.invoice.invoice_number;
    },
    currentTransporterGST() {
      const transporter = this.currentTransporter;
      return transporter.gst_details.find(gst => gst.client_id === this.currentClient.id);
    },
    ...mapGetters({
      currentTransporter: 'app/currentTransporter',
      currentClient: 'app/currentClient',
      transporterNonGst: 'app/transporterNonGst',
      currentClientConfig: 'app/currentClientConfig',
    }),
  },
  methods: {

    onCloseMenu() {
      // this.isOpen = false;
    },

    back() {
      // this.isOpen = true;
    },
    async create() {
      const payments = this.$store.payments;
      const destination = (payments.selected[0]) ? payments.selected[0].destination_state: ''; // It should be taken from transporter Profile state
      const service_recipient = (this.paidto) ? parseInt(this.paidto, 10) : this.currentTransporterGST.type;
      const source_state = (payments.selectedState && payments.selectedState.name) ? payments.selectedState.name: destination;
      const gst_number = payments.gstno;
      const igst = (payments.igst_tax) ? payments.igst_tax: payments.selected[0].igst_tax;
      const invoice_number = payments.invoiceno;
      const payment_ids = payments.selected.map(i => i.id);
      // const voucher_id = '';
      if(!payments.selectedState || !payments.selectedState.name) {
         this.$error({ message: 'Please select serivce provider state' });
         return false;
      }
      if (!gst_number || gst_number === '') {
        this.$error({ message: 'Please enter GST Number' });
         return false;
      }

      if (!invoice_number || invoice_number === '') {
        this.$error({ message: 'Please enter invocie Number' });
         return false;
      }

      if (gst_number && gst_number !== '' && invoice_number && invoice_number !== '') {
        const params = {
          service_recipient,
          source_state,
          gst_number,
          igst_tax: igst,
          invoice_number,
          payment_ids };
        try {
          let hasData = null;
          hasData = await this.$store.dispatch('payment/createinvoice', params);

          if(hasData.data && hasData.data.status !== 200) {
            const message = ( hasData.data.errors && hasData.data.errors[0].message) ? hasData.data.errors[0].message : 'Unable to Process';
            this.$error({ message: message });
            return false;
          } else {
            this.$success({ message: 'Invoice created' });
            await new Promise((resolve)=>setTimeout(()=>resolve(), 1000));
            this.$router.push({ name: 'PaymentList' });
          }
        } catch (e) {
          this.$error({ message: 'Unable to generate invoice' });
        }
      } else {
        this.$error({ message: 'GST No or Invoice No missing' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@common/styles-transporter/settings";

.back-arrow {
  transform: rotate(90deg);
}

.primary-filter {
    border: 1px solid #DEE5E6;
    background-color: #fff;
    height: 50px;
    margin-left: -20px;
    margin-right: -20px;
    font-family:$fontSemibold;
    .dropdown-menu {
        top: 32px !important;
    }
    .filter-grid {
        padding-left: 0;
        padding-right: 0;
        // border-left: 1px solid #CBD4D8;
        ul {
            @extend %list-unstyled;
            li {
                display: inline-block;
            }
            .app-side-menu {
                // background-color: #F2F1F1;
                padding: 14px 0;
                width: 69px;
                text-align: center;
                position: relative;
                top: -1px;
                background: #F2F1F1;
                cursor: pointer;
            }
            .category {
                width: 180px;
                padding: 5px 20px;
                color: #007FEA;
                padding-left: 10px;
                border-right: 1px solid #CBD4D8;
                border-left: 1px solid #CBD4D8;
                font-size: 1.4rem;
                text-transform: uppercase;
                margin-left: -3px;
                position: relative;
                top: -6px;
                height: 50px;
                .dropdown {
                    padding: 12px 10px;
                }
            }
            .search {
                padding: 0 20px;
                width: 50%;
                svg {
                    position: relative;
                    top: 0px;
                }
                input {
                    outline: none;
                    border: 1px solid transparent;
                    padding: 0 5px;
                    width: 90%;
                    font-size: 1.4rem;
                }
            }
        }
        &.filter-button {
            ul {
                @extend %list-unstyled;
                float: right;
                padding: 9.5px 10px;
                li {
                    margin: 0 0 0 18px;
                    &:last-child {
                        margin: 0 0 0 10px;
                    }
                    .btn-primary {
                        @extend %header-primary-btn;
                        @extend %bold;
                        color: #fff;
                        text-transform: uppercase;
                    }
                    .btn-secondary {
                        @extend %header-secondary-btn;
                        @extend %bold;
                        color: #008AFF;
                        text-transform: uppercase;
                    }
                }
            }
        }
    }
}
.hidden {
  visibility: hidden;
}
</style>
